import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslate } from 'hooks/useTranslate';

import GoBackButton from 'modules/_shared/components/Buttons/GoBackButton';
import { useAddIncentiveOfferPage } from '../context/AddIncentiveOfferPageContext';
import AddIncentiveOfferResumeSection from './AddIncentiveOfferResumeSection';
import AddIncentiveOfferDataSection from './AddIncentiveOfferDataSection';

const AddIncentiveOfferPageBody: FC = () => {
  const { t } = useTranslate();
  const history = useHistory();
  const { data } = useAddIncentiveOfferPage();

  if (data.isMarketClosed) {
    return (
      <div className="nk-block">
        <div className="alert alert-warning alert-icon mb-4" role="alert">
          <em className="icon ni ni-alert-circle" />
          <div>{t('MarketClosedOrUnavailable')}</div>
        </div>
        <GoBackButton
          icon="ni-arrow-left"
          customAction
          onClick={() => history.push(`/mercado-de-incentivos/${data.societyId}`)}
        />
      </div>
    );
  }

  return (
    <div className="nk-block invest-block oferta-detalle">
      <div className="row g-gs">
        <AddIncentiveOfferDataSection />

        <AddIncentiveOfferResumeSection />
      </div>
    </div>
  );
};

export default AddIncentiveOfferPageBody;
